/**
 * Inward Operations Module - Parent Component
 * Version: 2.0.0
 * Updated: 2024-12-21
 *
 * Description:
 *   Parent wrapper for Inward Operations sub-modules
 *   NEW FLOW: PO → Receiving (L1) → Grading (L2) → GRN → Packing (L3)
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import InwardDashboard from './InwardDashboard';
import POListPage from './PurchaseOrders/POListPage';
import POCreateForm from './PurchaseOrders/POCreateForm';
import PODetailPage from './PurchaseOrders/PODetailPage';
import VendorPricingManager from './PurchaseOrders/VendorPricingManager';

// Receiving Module (L1)
import ReceivingListPage from './Receiving/ReceivingListPage';
import ReceivingCreateModal from './Receiving/ReceivingCreateModal';
import ReceivingDetailPage from './Receiving/ReceivingDetailPage';

// Grading Module (L2)
import GradingQueuePage from './Grading/GradingQueuePage';
import GradingDetailPage from './Grading/GradingDetailPage';

// GRN Generation (New)
import GRNListPageNew from './GRN_New/GRNListPage';
import GRNDetailPageNew from './GRN_New/GRNDetailPage';

// Legacy GRN (Old structure)
import GRNListPage from './GRN/GRNListPage';
import GRNDetailPage from './GRN/GRNDetailPage';
import GRNDataEntryForm from './GRN/GRNDataEntryForm';

import GradingSorting from './GradingSorting';
import PackingLabeling from './PackingLabeling';

export default function InwardModule() {
    return (
        <Routes>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<InwardDashboard />} />

            {/* Purchase Orders */}
            <Route path="purchase-orders" element={<POListPage />} />
            <Route path="purchase-orders/create" element={<POCreateForm />} />
            <Route path="purchase-orders/:poId" element={<PODetailPage />} />
            <Route path="vendor-pricing" element={<VendorPricingManager />} />

            {/* Receiving Module (L1) - NEW */}
            <Route path="receiving" element={<ReceivingListPage />} />
            <Route path="receiving/create" element={<ReceivingCreateModal />} />
            <Route path="receiving/:id" element={<ReceivingDetailPage />} />

            {/* Grading Module (L2) - NEW */}
            <Route path="grading" element={<GradingQueuePage />} />
            <Route path="grading/:id" element={<GradingDetailPage />} />

            {/* GRN Generation (New Structure) */}
            <Route path="grn-new" element={<GRNListPageNew />} />
            <Route path="grn-new/:id" element={<GRNDetailPageNew />} />

            {/* Legacy GRN Management (Old Structure) */}
            <Route path="grn-legacy" element={<GRNListPage />} />
            <Route path="grn-legacy/:grnId" element={<GRNDetailPage />} />
            <Route path="grn-legacy/:grnId/edit" element={<GRNDataEntryForm />} />

            {/* Coming Soon */}
            <Route path="packing" element={<PackingLabeling />} />
        </Routes>
    );
}
